import { BaseQueryFn, FetchArgs, FetchBaseQueryError, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { store, type RootState } from '../../../stateManagement/store'
import { getItemWebStorage } from '../../../features/webStorageSaver'
import { logoutApp } from '../../../features/auth/logout'
import { showToastMessage } from '../../../stateManagement/reducers'

const baseQuery = fetchBaseQuery({
    baseUrl: `/`,
    prepareHeaders: (headers, { getState }) => {
        let token = (getState() as RootState).auth.tokens.app
        try {
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        } catch (error) {

        }
    }
})

const dynamicBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const urlEnd = typeof args === 'string' ? args : args.url
    const currentApiUrl = getItemWebStorage("currentApiUrl")
    const adjustedUrl = `${currentApiUrl}/${urlEnd}`
    const adjustedArgs = typeof args === 'string' ? adjustedUrl : { ...args, currentApiUrl, url: adjustedUrl }
    const result: any = await baseQuery(adjustedArgs, api, extraOptions)
    if (result.error) {
        const { originalStatus, status } = result?.error ?? {}
        if (originalStatus === 401 || status === 401) {
            setTimeout(() => store.dispatch(showToastMessage({ messageText: "Данные авторизации устарели. Авторизуйтесь снова", messageType: "error" })), 500)
            logoutApp()
        }
    }
    return result;
}

export const baseAPI = createApi({
    reducerPath: 'baseAPI',
    baseQuery: dynamicBaseQuery,
    endpoints: builder => ({}),
})

export const baseAPIReducer = baseAPI.reducer
export const resetBaseAPI = baseAPI.util.resetApiState